/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove course`)
};

const es_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar asignatura`)
};

const de_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurs entfernen`)
};

const nl_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vak verwijderen`)
};

const fr_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le cours`)
};

const it_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi corso`)
};

const pt_br2_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover disciplina`)
};

const pt_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover disciplina`)
};

const ja_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`科目を削除`)
};

const zh_gpa_remove = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除课程`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_remove = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_remove(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_remove", locale)
	if (locale === "en") return en_gpa_remove(inputs)
	if (locale === "es") return es_gpa_remove(inputs)
	if (locale === "de") return de_gpa_remove(inputs)
	if (locale === "nl") return nl_gpa_remove(inputs)
	if (locale === "fr") return fr_gpa_remove(inputs)
	if (locale === "it") return it_gpa_remove(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_remove(inputs)
	if (locale === "pt") return pt_gpa_remove(inputs)
	if (locale === "ja") return ja_gpa_remove(inputs)
	return zh_gpa_remove(inputs)
};